import { EnvironmentProviders } from '@angular/core';
import { provideStates } from '@ngxs/store';

import { SidenavState } from './store/sidenav.state';

export function provideSidenav(): EnvironmentProviders[] {
  return [provideStates([SidenavState])];
}
